// TODO refactor to using facepaint

export const mobile = '570px';
export const tablet = '768px';
